import OpCreate from './OpCreate';

export default OpCreate;
